@if ({
  overview: overview$ | async,
  errorOverview: errorOverview$ | async
  }; as type) {
  <!-- Filter and search -->
  <div class="cx-order-history-filter">
    <form (ngSubmit)="onSubmit()" #searchForm="ngForm" autocomplete="off">
      @if (showDefault) {
        <div class="form-group row">
          <label for="deliveryDateFrom" class="col-xl-2 col-form-label">{{
            'deliveryNotes.search.deliveryDateFrom' | cxTranslate
          }}</label>
          <div class="col-xl-2">
            <input
              type="date"
              id="deliveryDateFrom"
              class="form-control"
              [(ngModel)]="deliveryDateFrom"
              name="deliveryDateFrom"
              [(value)]="deliveryDateFrom"
              min="{{ deliveryDateFromMin }}"
              max="{{ deliveryDateFromMax | date: 'yyyy-MM-dd' }}"
              (change)="changeDeliveryDateFrom($event)"
              />
            </div>
            <label for="deliveryDateTo" class="col-xl-2 col-form-label">{{
              'deliveryNotes.search.deliveryDateTo' | cxTranslate
            }}</label>
            <div class="col-xl-2">
              <input
                type="date"
                id="deliveryDateTo"
                class="form-control"
                [(ngModel)]="deliveryDateTo"
                name="deliveryDateTo"
                [(value)]="deliveryDateTo"
                min="{{ deliveryDateToMin }}"
                max="{{ deliveryDateToMax | date: 'yyyy-MM-dd' }}"
                (change)="changeDeliveryDateTo($event)"
                />
              </div>
            </div>
            <div class="form-group row">
              <label for="deliveryId" class="col-md-2 col-form-label">{{
                'deliveryNotes.search.deliveryId' | cxTranslate
              }}</label>
              <div class="col-md-2">
                <input
                  type="text"
                  id="deliveryId"
                  class="form-control"
                  [(ngModel)]="deliveryId"
                  name="deliveryId"
                  [value]="deliveryId"
                  />
                </div>
                <label for="productCode" class="col-md-2 col-form-label">{{
                  'deliveryNotes.search.productCode' | cxTranslate
                }}</label>
                <div class="col-md-2">
                  <input
                    type="text"
                    id="productCode"
                    class="form-control"
                    [(ngModel)]="productCode"
                    name="productCode"
                    [value]="productCode"
                    />
                  </div>
                </div>
              }
              <div class="form-group row">
                @if (showDefault) {
                  <div class="col-sm-4">
                    <button class="btn btn-secondary btn-block mb-3" type="submit">
                      {{ 'deliveryNotes.buttons.search' | cxTranslate }}
                    </button>
                  </div>
                }
                @if (showDefault) {
                  <div class="col-sm-4">
                    <button class="btn btn-secondary btn-block mb-3" type="button" (click)="onReset()"
                      >
                      {{ 'deliveryNotes.buttons.reset' | cxTranslate }}
                    </button>
                  </div>
                }
                <div class="col-sm-4">
                  @if (!errorOverview && overview) {
                    <button
                      class="btn btn-secondary btn-block mb-3"
                      type="button"
                      (click)="onExport()"
                      >
                      {{ 'deliveryNotes.buttons.export' | cxTranslate }}
                    </button>
                  }
                </div>
              </div>
            </form>
          </div>
          @if (!errorOverview && overview) {
            <div
              class="cx-order-history-sort"
              >
              <div class="form-group row">
                <label for="deliveryNotes" class="col-xl-2 col-form-label">{{
                  'deliveryNotes.sortOptions.label' | cxTranslate
                }}</label>
                <ng-select
                  id="sortOptions"
                  class="col-xl-2"
                  [searchable]="false"
                  [clearable]="false"
                  (change)="onChangeSort()"
                  [(ngModel)]="selectedSortOption"
                  >
                  @for (sort of sortOptions; track sort) {
                    <ng-option [value]="sort">{{
                      'deliveryNotes.sortOptions.' + sort | cxTranslate
                    }}</ng-option>
                  }
                </ng-select>
                <label for="sortDirections" class="col-xl-2 col-form-label">{{
                  'deliveryNotes.sortDirections' | cxTranslate
                }}</label>
                <div class="col-xl-2 col-form-label">
                  <div class="form-check">
                    <input
                      class="form-check-input"
                      type="radio"
                      name="sortDirection"
                      id="sortDirectionDesc"
                      value="desc"
                      ng-control="sortDirection"
                      [(ngModel)]="sortDirection"
                      (change)="onChangeSort()"
                      />
                      <label class="form-check-label" for="sortDirectionDesc">
                        {{ 'deliveryNotes.sortDirection.desc' | cxTranslate }}
                      </label>
                    </div>
                  </div>
                  <div class="col-xl-2 col-form-label">
                    <div class="form-check">
                      <input
                        class="form-check-input"
                        type="radio"
                        name="sortDirection"
                        id="sortDirectionAsc"
                        value="asc"
                        ng-control="sortDirection"
                        [(ngModel)]="sortDirection"
                        (change)="onChangeSort()"
                        />
                        <label class="form-check-label" for="sortDirectionAsc">
                          {{ 'deliveryNotes.sortDirection.asc' | cxTranslate }}
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              }
              @if (overview || errorOverview) {
                <div [ngClass]="container">
                  <!-- BODY -->
                  <div class="cx-order-history-body">
                    @if (
                      !errorOverview && overview.entries.length>0) {
                      <!-- OVERVIEW/OPEN (default) table view -->
                      @if (showDefault) {
                        <app-delivery-notes-overview-table-default
                          [deliveryNotes]="deliveryNotes"
                        ></app-delivery-notes-overview-table-default>
                      }
                    } @else {
                      <div [ngClass]="'cx-order-history-no-order row'">
                        <div [ngClass]="'col-sm-12 col-md-6 col-lg-4'">
                          <div>{{ 'deliveryNotes.noDeliveryNotes' | cxTranslate }}</div>
                          <a
                            [routerLink]="{ cxRoute: 'home' } | cxUrl"
                            routerLinkActive="active"
                            class="btn btn-primary btn-block"
                            >{{ 'deliveryNotes.startShopping' | cxTranslate }}</a
                            >
                          </div>
                        </div>
                      }
                      <!-- NO ORDER CONTAINER -->
                    </div>
                  </div>
                } @else {
                  <cx-spinner></cx-spinner>
                }
              }
